import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UnifiedLoginService } from '@monorepo/services';
import {
  TREQUEST_GET_GROUP_PO_ORDER_LIST,
  TREQUEST_GROUP_LIST,
  TREQUEST_GROUP_LIST_VERSIONED_ID,
  TREQUEST_GROUP_FILTERS_SEARCH,
  TREQUEST_PRODUCT_TYPE_DETAILS_SHIPPABLE_ID,
  TREQUEST_UN_GROUP_VERSION_ID,
  TREQUEST_UPDATE_GROUP,
  TRESPONSE_GET_GROUP_PO_ORDER_LIST,
  TRESPONSE_GROUP_AND_INDIVIDUAL_BCTX_LIST,
  TRESPONSE_GROUP_FILTERS_SEARCH,
  TRESPONSE_PRODUCT_TYPE_DETAILS_SHIPPABLE_ID,
  TResponseWithStatusAndErrorMessage,
  TREQUEST_GROUP_LIST_BY_BCTX,
} from '@monorepo/types';
import { OrderUploadEndPoint, OrderUploadEnvProvider } from './order-upload.env.provider';
import { of } from 'rxjs';
import { groupPoOrderList, productTypeDetails } from './mocks';

@Injectable({
  providedIn: 'root',
})
export class OrderUploadDataService {
  constructor(
    private http: HttpClient,
    private orderUploadEnvProvider: OrderUploadEnvProvider,
    public unifiedLoginService: UnifiedLoginService,
  ) {}

  fetchGroupPoOrderListData(payload: TREQUEST_GET_GROUP_PO_ORDER_LIST) {
    console.log('fetchGroupPoOrderListData', payload);
    const url = this.orderUploadEnvProvider.getUrlFromEnv('GET_BCTX_GROUP_LISTING');
    return this.http.post<TResponseWithStatusAndErrorMessage<TRESPONSE_GET_GROUP_PO_ORDER_LIST>>(url, payload);
    // return of(groupPoOrderList);
  }

  fetchOrderGroupUngroupPopupListData(payload: TREQUEST_GROUP_LIST_VERSIONED_ID) {
    console.log('fetchGroupUngroupPopupList', payload);
    const url = this.orderUploadEnvProvider.getUrlFromEnv('GET_BCTX_GROUP_AND_INDEPENDENT_BCTX_LIST_VERSIONED_ID');
    return this.http.post<TResponseWithStatusAndErrorMessage<TRESPONSE_GROUP_AND_INDIVIDUAL_BCTX_LIST>>(url, payload);
    // return of(orderGroupUngroupPoList);
  }

  fetchOrderGroupUngroupPopupListDataByBctx(payload: TREQUEST_GROUP_LIST_BY_BCTX) {
    console.log('fetchGroupUngroupPopupList', payload);
    const url = this.orderUploadEnvProvider.getUrlFromEnv('GET_BCTX_GROUP_AND_INDEPENDENT_BCTX_LIST_BCTX_ITEMS');
    return this.http.post<TResponseWithStatusAndErrorMessage<TRESPONSE_GROUP_AND_INDIVIDUAL_BCTX_LIST>>(url, payload);
    // return of(orderGroupUngroupPoList);
  }

  updateGroupPos(payload: TREQUEST_UPDATE_GROUP) {
    console.log('updateGroupPos', payload);
    const url = this.orderUploadEnvProvider.getUrlFromEnv('UPDATE_BCTX_GROUPS');
    return this.http.post<TResponseWithStatusAndErrorMessage<null>>(url, payload);
    // return of({});
  }

  unGroupPos(payload: TREQUEST_UN_GROUP_VERSION_ID) {
    console.log('updateGroupPos', payload);
    const url = this.orderUploadEnvProvider.getUrlFromEnv('UNGROUP_BY_VERSIONED_ID');
    return this.http.post<TResponseWithStatusAndErrorMessage<null>>(url, payload);
    // return of({});
  }

  productTypeDetailsByShippableId(payload: TREQUEST_PRODUCT_TYPE_DETAILS_SHIPPABLE_ID) {
    console.log('productTypeDetailsByShippableId', payload);
    const url = this.orderUploadEnvProvider.getUrlFromEnv('GET_BCTX_LIST_SHIPPABLE_ID');
    return this.http.post<TResponseWithStatusAndErrorMessage<TRESPONSE_PRODUCT_TYPE_DETAILS_SHIPPABLE_ID>>(
      url,
      payload,
    );
    // return of(productTypeDetails);
  }

  getFiltersSearchResults(endPoint: keyof typeof OrderUploadEndPoint, payload: TREQUEST_GROUP_FILTERS_SEARCH) {
    console.log('getFiltersSearchResults', payload);
    const { factoryId } = this.unifiedLoginService.getUserInfo();
    payload['subjectKey'] = factoryId;
    const url = this.orderUploadEnvProvider.getUrlFromEnv(endPoint);
    return this.http.post<TResponseWithStatusAndErrorMessage<TRESPONSE_GROUP_FILTERS_SEARCH>>(url, payload);
    // return of({ values: ['buyer3', 'buyer4'] });
  }
}
